<template>
    <section id="app-cart" class="uk-container uk-flex-auto">
        <div v-if="proofcard != ''" class="uk-text-center">
            <img :src="proofcard" alt="">
        </div>

        <div id="cart-items" class="uk-margin">
            <h3 class="uk-text-center uk-margin-remove-bottom uk-h2">Basket</h3>
            <table class="uk-table uk-table-justify uk-table-middle uk-table-small">
                <thead>
                    <tr>
                        <th class="uk-table-shrink"><span class="uk-hidden">item</span></th>
                        <th class="uk-table-expand"><span class="uk-hidden">item</span></th>
                        <th class=""><span class="uk-hidden">item</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in cartProducts" :key="item.key">
                        <td class="sp-cart-item-td">
                            <div class="sp-cart-item-container uk-position-relative">
                                <span class="sp-cart-item-quantity uk-badge uk-position-top-right">{{ item.quantity }}</span>
                                <div class="sp-cart-item-thumbnail uk-cover-container uk-background-primary">
                                    <img :src="item.thumbnail" :alt="item.content" uk-cover>
                                    <canvas width="60" height="60"></canvas>
                                </div>
                            </div>
                        </td>
                        <td>
                            <h3 class="uk-h5 uk-margin-remove uk-margin-remove-adjacent">{{ item.package }}</h3>
                            <div class="uk-text-small">{{ item.content }}</div>
                            <div class="uk-text-small uk-text-meta">{{ item.product_code }}</div>
                        </td>
                        <td class="uk-text-right">
                            <div>{{ currency(item.price) }} <span class="uk-text-small">Each</span></div>
                            <div>
                                <div class="uk-button-group">
                                    <button class="uk-button uk-button-default uk-button-small" type="button" @click="removeProductFromCart(item)">-</button>
                                    <button class="uk-button uk-button-default uk-button-small" type="button" @click="addProductToCart(item)">+</button>
                                </div>
                            </div>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>

        <div id="cart-totals">
            <table class="uk-table uk-table-divider uk-table-justify uk-table-middle">
                <thead>
                    <tr>
                        <th scope="row"><span class="uk-hidden">Description</span></th>
                        <th colspan="3" class="uk-text-right"><span class="uk-hidden">Price</span></th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">
                            <div>Subtotal</div>
                        </th>
                        <td class="uk-text-right">
                            <div>{{ currency(cartSubTotal) }} <span class="uk-text-small">GBP</span></div>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <div>Select Delivery</div>
                        </th>
                        <td class="uk-text-right" uk-margin>
                            <button class="uk-button-default uk-button" @click="this.$store.state.school_delivery = false">Home (£4.00)</button>
                            <button class="uk-button-default uk-button" @click="this.$store.state.school_delivery = true">School (free)</button>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">
                            <div>Delivery</div>
                        </th>
                        <td class="uk-text-right">
                            <div v-if="this.$store.state.school_delivery == true">FREE Pick up at school</div>
                            <div v-else>Home {{ currency(cartShippingTotal) }} <span class="uk-text-small">GBP</span></div>
                        </td>
                    </tr>
                    <tr v-if="cartLateFee != 0">
                        <th scope="row">
                            <div>Late Fee</div>
                        </th>
                        <td class="uk-text-right">
                            <div>{{ currency(cartLateFee) }} <span class="uk-text-small">GBP</span></div>
                        </td>
                    </tr>
                    <tr>
                        <th scope="row">Total</th>
                        <td class="uk-text-right">
                            <span class="uk-h4 uk-text-bold">{{ currency(cartTotal) }}</span> GBP
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div id="checkout-buttons">
            <div uk-grid>
                <div class="uk-width-1-2">
                    <button v-if="this.$route.name == 'Checkout'" disabled class="uk-button uk-button-primary uk-input-rounded">Checkout</button>
                    <router-link v-else class="uk-button uk-button-primary uk-input-rounded" :to="{ name: 'Checkout' }">Checkout</router-link>
                </div>
                <div class="uk-width-1-2">
                    <button @click="startAgain()" class="uk-button uk-button-secondary uk-input-rounded">
                        <span>Start Again</span>
                    </button>
                </div>
            </div>
            <!-- <a class="uk-button uk-button-primary" @click="checkout">Checkout</a> -->
            <!-- <div v-if="checkoutStatus == 'success'">
                <div class="uk-alert-success" uk-alert>
                    <a class="uk-alert-close" uk-close @click="$store.commit('setCheckoutStatus', null)"></a>
                    <p>Checout Successful</p>
                </div>
            </div>
            <div v-if="checkoutStatus == 'failed'">
                <div class="uk-alert-danger" uk-alert>
                    <a class="uk-alert-close" uk-close @click="$store.commit('setCheckoutStatus', null)"></a>
                    <p>Checout Failed</p>
                </div>
            </div> -->
        </div>

        <div v-if="proofcard != ''" class="uk-width-1-1">
            <div>
                <div id="customer-details">
                    <table class="uk-table uk-table-divider uk-table-justify uk-table-middle">
                        <thead>
                            <tr>
                                <th width="170" scope="row"><span class="uk-hidden">Description</span></th>
                                <th class="uk-text-right"><span class="uk-hidden">Data</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th scope="row" class="">
                                    <div>School</div>
                                </th>
                                <td class="uk-text-right">
                                    <div>{{ school.name }}</div>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" class="">
                                    <div>Order Cutoff Date</div>
                                </th>
                                <td class="uk-text-right">
                                    <div>{{ school.order_cutoff_date }}</div>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" class="">
                                    <div>Late Fee</div>
                                </th>
                                <td class="uk-text-right">
                                    <div>Orders after the cutoff date will incur a late fee of {{ currency(this.$store.state.cart_totals.late_fee) }}</div>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row" class="">
                                    <div>Online Code</div>
                                </th>
                                <td class="uk-text-right">
                                    <div>{{ customer.online_code }}</div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { currency } from "@/filters/currency"
import { mapState, mapGetters, mapActions } from "vuex"

export default {
    computed: {
        ...mapGetters ({
            cartProducts: 'cartProducts',
            cartSubTotal: 'cartSubTotal',
            cartLateFee: 'cartLateFee',
            cartShippingTotal: 'cartShippingTotal',
            cartTotal: 'cartTotal',
            customer: 'customer',
            school: 'school',
            proofcard: 'proofcard',
        }),
        ...mapState ({
            checkoutStatus: 'checkout_status',
        }),
    },

    methods: {
        currency,
        ...mapActions ({
            addProductToCart:      'addProductToCart',
            removeProductFromCart: 'removeProductFromCart',
            checkout:              'checkout',
            deliverToSchool:       'deliverToSchool',
            startAgain:            'startAgain',
        }),
    },
};
</script>

<style>
.sp-cart-item-thumbnail {
    width: 60px;
}

.sp-cart-item-quantity {
    z-index: 1;
}

.sp-cart-item-td {
    padding: 0;
}

.sp-cart-item-container {
    padding: 10px 12px 0 0;
}
</style>
